const sprite = (name: string) => `/brand/sprites/${name}.webp`;

export const BRAND_SPRITES = {
  logo: sprite('logo-square'),
  logoCrest: sprite('logo-crest'),
  pinHero: sprite('pin-hero'),
  pinPounce: sprite('pin-pounce'),
  pinCelebrate: sprite('pin-celebrate'),
  pinSit: sprite('pin-sit'),
  pinCurl: sprite('pin-curl'),
  pinHeadCalm: sprite('pin-head-calm'),
  pinHeadSly: sprite('pin-head-sly'),
  pinHeadAngry: sprite('pin-head-angry'),
  pinHeadWink: sprite('pin-head-wink'),
} as const;

const previewPoses = [
  BRAND_SPRITES.pinHeadCalm,
  BRAND_SPRITES.pinHeadSly,
  BRAND_SPRITES.pinHeadAngry,
  BRAND_SPRITES.pinHeadWink,
] as const;

export function pinPreviewPose(seed: number): string {
  return previewPoses[Math.abs(seed) % previewPoses.length]!;
}
